<template>
  <div class="page">
    <toobarhead :showRefresh="showRefresh" :showMore="showMore" :showBack="false" :titleName="titleName" v-on:refreshList="refresh"
    v-on:showmoremenu="showmoremenu"></toobarhead>
    <div class="fixed-rb" id="gotop" @click.prevent.stop="gotop">
      <i class="gotop"></i>
    </div>
    <div class="page__bd" style="height: 100%;">
        <div class="weui-tab">
            <div class="weui-navbar" v-show="showNavbar">
                <div v-for="(menu, index) in mainmenus" class="weui-navbar__item"
                v-bind:class="{'weui-bar__item_on' : selected===index}"
                @click='requestInfo(index, menu.viewtype, true, false, "合同信息", false)'>
                {{menu.text}}
                </div>
            </div>
            <div class="weui-tab__panel">
              <contractlist :listInfo="getInfo" :viewType="viewtype"></contractlist>
            </div>
            <!-- <div class="weui-loadmore" v-show='showLoading'>
              <i class="weui-loading"></i>
              <span class="weui-loadmore__tips">正在加载</span>
            </div> -->
            <div class="more" v-if='btn_requestMore && list && list.length != 0'>
              <button class="weui-btn weui-btn_plain-default" @click='requestMore()'>加载更多</button>
            </div>
            <div v-if='list.length == 0 && !showLoading' class="weui-loadmore weui-loadmore_line">
              <span class="weui-loadmore__tips">暂无数据</span>
            </div>
        </div>
    </div>
    <div>
      <div class="weui-mask" id="iosMask" v-show="false" @click.stop="hidenMask"></div>
      <div class="weui-actionsheet" id="actionsheet">
        <div class="weui-actionsheet__menu">
          <div class="weui-actionsheet__cell" @click="requestInfo( 0, 'audit', true, false, '合同信息', false)" v-show="!showNavbar">合同信息</div>
          <div class="weui-actionsheet__cell" v-for=" (secondm, index) in secondmenus" @click="requestInfo( -(index+2), secondm.viewtype, false, true, secondm.text, false)" v-show="titleName != secondm.text">{{secondm.text}}</div>
        </div>        <div class="weui-actionsheet__action">
          <div class="weui-actionsheet__cell" @click="loginout">退出登录({{userName}})</div>
          <div class="weui-actionsheet__cell" @click="hidenMask">取消</div>
        </div>
      </div>
    </div>
    <div class="list_loadingToast" v-show='showLoading'>
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">加载中...</p>
      </div>
    </div>
    <div class="js_dialog loginoutDlg" style="display: none;">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">退出登录</strong></div>
        <div class="weui-dialog__bd">确定退出吗</div>
        <div class="weui-dialog__ft">
          <a class="weui-dialog__btn weui-dialog__btn_default" @click.prevent="stayin">放弃</a>
          <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent="goout">确定</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import contractlist from './list'
  import toobarhead from './head'
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        userName: '',
        selected: -1,  // 当前选择中TAB index
        showLoading: false,
        showMore: true,
        showRefresh: true,
        showNavbar: true,
        showBack: false,
        btn_requestMore: false,
        moremenu: {},
        menumask: {},
        titleName: '合同信息',
        page: {
          pageNumber: 1,
          pageSize: 5,
          totalPage: 1,
          totalRow: 0,
          firstPage: true,
          lastPage: true
        },
        viewtype: '',
        list: [],
        scrollTop: {},
        mainmenus: {},
        secondmenus: {}
      }
    },
    mounted: function () {
      this.getUserInfo()
      this.$nextTick(function () {
        let random = this.$route.query.randomKey
        let param = ''
        if (random && random.length > 0) {
          param = '?randomKey=' + random
        }
        let sel = this.$route.query.selected
        if (!sel) {
          sel = 0
        }
        this.$http.get('rest/api/menu' + param).then(function (response) {
          if (response.data) {
            this.mainmenus = response.data.mainmenu
            if (response.data.secondmenu && response.data.secondmenu.length > 0) {
              this.secondmenus = response.data.secondmenu
              this.showMore = true
            }
            this.moremenu = window.$('#actionsheet')
            this.menumask = window.$('#iosMask')
            // this.selected = Number(this.$route.query.selected)
            this.showNavbar = (this.$route.query.showNavbar + '') === 'true'
            this.showBack = (this.$route.query.showBack + '') === 'true'
            if (this.$route.params.op === 'index') {
              this.page.viewtype = this.mainmenus[0].viewtype
              this.viewtype = this.mainmenus[0].viewtype
              this.showNavbar = true
            } else {
              this.page.viewtype = this.$route.params.op
              this.viewtype = this.$route.params.op
            }
            let refresh = false
            if (this.$route.query.refresh) {
              refresh = (this.$route.query.refresh + '') === 'true'
            }
            if (this.$route.query.tname) {
              this.titleName = this.$route.query.tname
            }
            // window.alert(this.$route.query.selected)
            this.requestInfo(Number(sel), this.viewtype, this.showNavbar, this.showBack, this.titleName, refresh)
          }
        })
      })
      let wh = window.$(window).height()
      let el = window.$('#gotop')
      window.onscroll = function () {
        this.scrollTop = window.$('body').scrollTop()
        if (this.scrollTop >= wh) {
          el.css('display', 'block')
        } else {
          el.css('display', 'none')
        }
        return this.scrollTop
      }
    },
    computed: {
      getInfo: function () {
        switch (this.viewtype) {
          case 'audit':
            this.list = this.$store.getters.auditPage.list
            this.page = this.$store.getters.auditPage
            this.btn_requestMore = !(this.$store.getters.auditPage.lastPage)
            break
          case 'cc':
            this.list = this.$store.getters.ccPage.list
            this.page = this.$store.getters.ccPage
            this.btn_requestMore = !(this.$store.getters.ccPage.lastPage)
            break
          case 'history':
            this.list = this.$store.getters.historyPage.list
            this.page = this.$store.getters.historyPage
            this.btn_requestMore = !(this.$store.getters.historyPage.lastPage)
            break
          case 'seal':
            this.list = this.$store.getters.sealPage.list
            this.page = this.$store.getters.sealPage
            this.btn_requestMore = !(this.$store.getters.sealPage.lastPage)
            break
          case 'file':
            this.list = this.$store.getters.filePage.list
            this.page = this.$store.getters.filePage
            this.btn_requestMore = !(this.$store.getters.filePage.lastPage)
            break
          default:
        }
        return this.list
      }
    },
    watch: {
      '$route' (to, from) {
        this.showNavbar = (this.$route.query.showNavbar + '') === 'true'
        this.showBack = (this.$route.query.showBack + '') === 'true'
        this.selected = Number(to.query.selected)
        this.viewtype = to.params.op
        this.titleName = to.query.tname
      }
    },
    components: {
      contractlist,
      toobarhead
    },
    methods: {
      ...mapActions([
        'getDataList'
      ]),
      loginout () {
        this.moremenu.removeClass('weui-actionsheet_toggle')
        this.menumask.fadeOut(200)
        window.$('.loginoutDlg').fadeIn(200)
      },
      getUserInfo () {
        this.$http.get('rest/user/me').then(res => {
          this.userName = res.data.user.user_name
        }, res => {
        })
      },
      goout () {
        this.$http.get('rest/api/loginout').then(function (response) {
          window.$('#audit .js_dialog').fadeOut(100)
          if (response.data.ok) {
            this.$router.push({path: '/login/-1/-1'})
          }
        }, function (response) {
        })
      },
      stayin () {
        window.$('.loginoutDlg').fadeOut(100)
      },
      showmoremenu () {
        this.moremenu.addClass('weui-actionsheet_toggle')
        this.menumask.fadeIn(200)
      },
      hidenMask () {
        this.moremenu.removeClass('weui-actionsheet_toggle')
        this.menumask.fadeOut(200)
      },
      refresh () {  // 刷新
        let vm = this
        if (vm.showLoading) {
          return
        }
        vm.resetProperty()
        vm.page.viewtype = vm.$route.params.op
        vm.viewtype = vm.$route.params.op
        vm.page.refresh = true
        vm.showLoading = true
        vm.getDataList(vm.page).then(function () {
          vm.showLoading = false
        }, function () {
          vm.showLoading = false
        })
      },
      requestInfo (index, type, showNavbar, showBack, tname, isRefresh) {
        let vm = this
        vm.hidenMask()
        if (vm.selected === index) {
          return
        }
        vm.titleName = tname
        vm.selected = index
        vm.viewtype = type
        vm.page.viewtype = type
        vm.page.refresh = isRefresh
        let number
        switch (type) {
          case 'audit':
            number = vm.$store.getters.auditPage.pageNumber
            break
          case 'cc':
            number = vm.$store.getters.ccPage.pageNumber
            break
          case 'history':
            number = vm.$store.getters.historyPage.pageNumber
            break
          case 'seal':
            number = vm.$store.getters.sealPage.pageNumber
            break
          case 'file':
            number = vm.$store.getters.filePage.pageNumber
            break
          default:
        }
        if (!number || vm.page.refresh) { // 没有初始化就查询
          vm.showLoading = true
          vm.getDataList(vm.page).then(function () {
            vm.showLoading = false
            vm.$router.push({path: '/list/' + vm.viewtype, query: {showNavbar: showNavbar, showBack: showBack, selected: vm.selected, tname: vm.titleName}})
          }, function () {
            vm.showLoading = false
          })
        } else {
          vm.$router.push({path: '/list/' + vm.viewtype, query: {showNavbar: showNavbar, showBack: showBack, selected: vm.selected, tname: vm.titleName}})
        }
      },
      requestMore () {  // 加载更多
        let vm = this
        if (vm.showLoading) {
          return
        }
        if (vm.page.pageNumber < vm.page.totalPage) {
          if (vm.page.pageNumber < 3) {
            vm.page.pageNumber += 1
          } else {
            vm.btn_requestMore = false
            return
          }
        }
        vm.page.refresh = false
        vm.page.viewtype = vm.viewtype
        vm.showLoading = true
        vm.getDataList(vm.page).then(function () {
          vm.showLoading = false
        }, function () {
          vm.showLoading = false
        })
      },
      resetProperty () {
        this.page.pageNumber = 1
        this.page.pageSize = 5
        this.page.totalPage = 1
        this.page.totalRow = 0
        this.page.lastPage = true
        this.page.firstPage = true
        this.list = []
      },
      gotop () {
        let timer = null
        clearInterval(timer)
        timer = setInterval(function () {
          var speed = (0 - this.scrollTop) / 5
          speed = Math.floor(speed)
          if (this.scrollTop === 0) {
            clearInterval(timer)
          }
          window.$('body').scrollTop(this.scrollTop + speed)
        }, 30)
      }
    }
  }
</script>
<style type="text/css">
    .more{
        padding: 15px;
        margin: 0 auto;
    }
    /*gotop*/
    .fixed-rb {position: fixed;right: 1.25rem;bottom: 3rem;width: 44px;height: 44px; display: none; z-index: 1;}
    .gotop{width: 44px; height: 44px; background: url(/static/image/arrow_up.png) center center no-repeat rgba(0,0,0,0.6); display: block; border-radius: 5px;}
</style>



// WEBPACK FOOTER //
// index.vue?22c97f09